import { PaymentGroupStatus } from 'store/stores';

export const errorStatuses = [
  PaymentGroupStatus.failed,
  PaymentGroupStatus.cancelled,
];

export const PAID_KEY_COOKIE = 'paid_key';
